var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product.bylActionableLink
    ? _c(
        "BaseModal",
        {
          attrs: {
            bem: _vm.bemBlock,
            "close-on-backdrop-interaction": true,
            "has-mini-cart": _vm.showMinicart,
            "small-close-with-text": _vm.showMinicart,
            "is-open": _vm.isOpen,
            "modal-modifier":
              _vm.modalModifier !== ""
                ? _vm.modalModifier
                : "actionable-link-display",
            "show-backdrop": true
          },
          on: {
            closed: function($event) {
              return _vm.$emit("closed")
            }
          }
        },
        [
          _c("h2", { class: _vm.bemElement("title") }, [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.bemElement("container"), attrs: { role: "document" } },
            [
              _vm.loading ? _c("BaseSpinner") : _vm._e(),
              _vm._v(" "),
              _vm.isDisplayTypeGrid
                ? _c("BaseProductGrid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.products && _vm.products.length > 0,
                        expression: "products && products.length > 0"
                      }
                    ],
                    class: [
                      _vm.bemElement("results", {
                        grid: _vm.isDisplayTypeGrid
                      }),
                      "u-scrollbar-byl"
                    ],
                    attrs: {
                      analytics: {
                        location: _vm.analyticsConst.location.crossSellingGrid
                      },
                      products: _vm.products,
                      "show-swatches": false,
                      type: "crossSelling",
                      "infinite-next": true
                    },
                    on: { "infinite:next": _vm.fetchNextPage }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }